var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransparentpaperplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1027.249,
    height: 844.85,
    viewBox: "0 0 1027.249 844.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.953,
    y1: -0.074,
    x2: 0.191,
    y2: 0.925,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc4646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec00ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(68.63 -2839.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M-8945.183-545.939s98.224,195.876,246.7,139.34,79.378-245.559,267.259-299.239,352.919,209.01,484.264,84.518-248.985-468.274-100.508-561.929",
    transform: "translate(8877 4080)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    strokeDasharray: 9,
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(626.581 2701.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M217.4,207.046l5.961,18.277a1.922,1.922,0,0,0,3.054.887l17.833-14.73s-18.966-7.389-18.966-7C225.331,204.878,217.4,207.046,217.4,207.046Z",
    transform: "translate(-18.286 -33.672)",
    fill: "#d82045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M246.21,138.249c-11.675,4.631-49.263,20-63.5,25.863a2.182,2.182,0,0,0,.148,4.089l16.257,5.173,5.961,18.227a1.993,1.993,0,0,0,1.527,1.33c.542.1,1.379-14.73,1.379-14.73s17.094,12.661,25.173,18.671a3.382,3.382,0,0,0,5.32-2.069c2.414-12.464,8.473-43.549,10.493-54.189A2.069,2.069,0,0,0,246.21,138.249Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M224.939,206.689c.542.1,1.379-14.73,1.379-14.73L254.4,165.6c.2-.2-.049-.493-.246-.345L217.5,187.181l5.961,18.227A1.879,1.879,0,0,0,224.939,206.689Z",
    transform: "translate(-18.337 -13.758)",
    fill: "#f559bf"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentpaperplane);
export default __webpack_public_path__ + "static/media/transparent paperplane.5dbada391428ea181d9606f06004b8e3.svg";
export { ForwardRef as ReactComponent };